<template>
	<div v-html="qwq">
	</div>
</template>

<script>
	export default {
		name: "applyText",
		data() {
			return {
				qwq: this.$route.query.htmlData
			}
		},
		mounted() {
			console.log(this.qwq)
			this.$nextTick(() => {
				document.forms[0].submit()
			})
		}
	}
</script>

<style>
</style>
